<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rDADTS/tc-custom/9780253109262.jpg?1737196285841" alt="This image is the cover for the book Haitian Revolutionary Studies, Blacks in the Diaspora"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haitian Revolutionary Studies, Blacks in the Diaspora
      </h1>
      <p class="bookDescription body article font2">
        <p>The Haitian Revolution of 1789–1803 transformed the Caribbean's wealthiest colony into the first independent state in Latin America, encompassed the largest slave uprising in the Americas, and inflicted a humiliating defeat on three colonial powers. In Haitian Revolutionary Studies, David Patrick Geggus sheds new light on this tremendous upheaval by marshaling an unprecedented range of evidence drawn from archival research in six countries.  Geggus's fine-grained essays explore central issues and little-studied aspects of the conflict, including new historiography and sources, the origins of the black rebellion, and relations between slaves and free people of color. The contributions of vodou and marronage to the slave uprising, Toussaint Louverture and the abolition question, the policies of the major powers toward the revolution, and its interaction with the early French Revolution are also addressed. Questions about ethnicity, identity, and historical knowledge inform this essential study of a complex revolution.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Patrick Geggus
      </h2>
      
      <p class="authorDescription body article"><P>David Patrick Geggus is Professor of History at the University of Florida, Gainesville.  He is the author of Slavery, War, and Revolution, editor of The Impact of the Haitian Revolution in the Atlantic World, and co-editor (with David Barry Gaspar) of A Turbulent Time: The French Revolution and the Greater Caribbean (Indiana University Press).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33d4c556